import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import AppShellShadcn from './layout/AppShell.shadcn';
import { Home, DeckBuilder, CardGallery, About, SampleDecks, DeckView, Blog, BlogPost, Videos } from './pages';
import { TooltipProvider } from './components/ui/tooltip';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <TooltipProvider>
        <BrowserRouter>
          <LanguageProvider>
            <Routes>
              <Route path="/" element={<AppShellShadcn />}>
                <Route index element={<Home />} />
                <Route path="deck-builder" element={<DeckBuilder />} />
                <Route path="gallery" element={<CardGallery />} />
                <Route path="decks" element={<SampleDecks />} />
                <Route path="decks/view/:deckId" element={<DeckView />} />
                <Route path="about" element={<About />} />
                <Route path="blog" element={<Blog />} />
                <Route path="blog/:slug" element={<BlogPost />} />
                <Route path="videos" element={<Videos />} />
              </Route>
            </Routes>
          </LanguageProvider>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  );
}

export default App;
